export default {
  "footer": "_footer_4ejav_1",
  "closeIcon": "_closeIcon_4ejav_18"
};import "ni:sha-256;Zg9JbBlAfJKML6dMhxyK8e5f_MtjqZBDs_AKkzDCP0c";